import { useMutation, type MutationHookOptions } from "@apollo/client"
import tenantRestoreMutation from "@/v2-backoffice-client/tenant/restore/tenant.restore.mutation.gql"
import type {
  TenantRestoreMutation,
  TenantRestoreMutationVariables,
} from "@/v2-backoffice-client/tenant/restore/__types__/tenant.restore.mutation"

type RestoreOptions = MutationHookOptions<
  TenantRestoreMutation,
  TenantRestoreMutationVariables
>

export function useTenantRestoreMutation(options?: RestoreOptions) {
  return useMutation<TenantRestoreMutation, TenantRestoreMutationVariables>(
    tenantRestoreMutation,
    options,
  )
}
